<template>
  <div class="report-export-progress" role="status" aria-live="polite">
    <!-- Спиннер показывается только во время работы, итоговый статус остается до закрытия диалога. -->
    <div v-if="progress.active" class="report-export-progress__spinner-wrap" aria-hidden="true">
      <SpinnerLoading class="report-export-progress__spinner" color="blue" />
    </div>
    <div class="report-export-progress__content">
      <div class="report-export-progress__heading">
        <span>{{ caption }}</span>
        <strong class="report-export-progress__percent">{{ progress.percent }}%</strong>
      </div>
      <progress
        class="report-export-progress__bar"
        :value="progress.percent"
        max="100"
        :aria-label="caption"
      />
      <!-- Число страниц становится известно после первого ответа API. -->
      <div v-if="progress.pages" class="report-export-progress__details">
        {{ $t('reportExportPages', {current: progress.page, total: progress.pages}) }}
        · {{ $t('reportExportRows', {count: progress.rows}) }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Индикатор постраничной выгрузки отчета и подготовки файла.
 * Получает состояние из общей примеси выгрузки; запросы и расчет процента выполняются в ней.
 */
export default {
  name: "ReportExportProgress",
  props: {
    /**
     * Общее реактивное состояние выгрузки.
     * active управляет спиннером, phase определяет подпись, percent содержит процент готовности,
     * page, pages и rows показывают текущую страницу, общее число страниц и количество обработанных строк.
     */
    progress: {type: Object, required: true},
  },
  computed: {
    /**
     * @return {String} Локализованная подпись текущего этапа или результата выгрузки.
     */
    caption() {
      if (this.progress.phase === "cancelled") return this.$t('reportExportCancelled');
      if (this.progress.phase === "cancelling") return this.$t('reportExportCancelling');
      if (this.progress.phase === "complete") return this.$t('reportExportReady');
      if (this.progress.phase === "finalizing") return this.$t('reportExportPreparing');
      return this.$t('reportExportLoading');
    },
  },
};
</script>

<style scoped lang="scss">
.report-export-progress {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
  margin: 12px 0;
  padding: 16px;
  border: 1px solid #dbe8f4;
  border-radius: 8px;
  background: #f5faff;

  &__spinner-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }

  &__spinner {
    font-size: 5px;
    margin: 0;
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__heading {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
  }

  &__percent {
    font-variant-numeric: tabular-nums;
  }

  &__bar {
    display: block;
    width: 100%;
    height: 6px;
    border: 0;
    border-radius: 3px;
    overflow: hidden;
    appearance: none;
    background: #dbe8f4;

    &::-webkit-progress-bar {
      background: #dbe8f4;
    }

    &::-webkit-progress-value {
      background: #2196f3;
      transition: width .2s ease;
    }

    &::-moz-progress-bar {
      background: #2196f3;
    }
  }

  &__details {
    margin-top: 8px;
    color: #63758b;
    font-size: 12px;
  }
}
</style>
